module.exports = __webpack_public_path__ + "img/szwy.8b4a0a04.jpg";